import axios_instance from "../axios.config";

const RegisterNewUser = async (credentials: any) => {
  const {
    id,
    username,
    password,
    role,
    permissions,
    staff_id = "",
  } = credentials;
  const payload = {
    id,
    username,
    password,
    role,
    permissions,
    staff_id,
  };
  const response = await axios_instance.post("/auth/registeruser", payload);
  console.log(response);
  if (response?.data?.status === "SUCCESS") {
    return response.data;
  } else {
    return [];
  }
};

const Login = async (credentials: any) => {
  const { username, password } = credentials;
  const payload = {
    username,
    password,
  };
  const response = await axios_instance.post("/auth/login", payload);
  console.log(response);
  if (response?.data?.status === "SUCCESS") {
    return response.data;
  } else {
    return [];
  }
};

const FetchUser = async (staff_id: string) => {
  const payload = {
    staff_id,
  };
  const response = await axios_instance.post("/auth/fetchuser", payload);
  console.log(response);
  if (response?.data?.status === "SUCCESS") {
    return response.data;
  } else {
    return [];
  }
};

const UpdatePassword = async (updatedObj: any) => {
  const { id, password } = updatedObj;
  const payload = {
    id,
    password,
  };
  const response = await axios_instance.post("/auth/update-password", payload);
  console.log(response);
  if (response?.data?.status === "SUCCESS") {
    return response.data;
  } else {
    return [];
  }
};

export { Login, FetchUser, RegisterNewUser, UpdatePassword };
